import type { Action } from '@0xtorch/core'
import type { Chain } from '../../chain'
import type { LowerHex } from '../../types'
import type { AnalyzeDataSource } from '../../types/analyzeDataSource'
import type { Converter } from '../../types/converter'
import type { TransactionDecoded } from '../../types/transactionDecoded'
import type { TransactionDetail } from '../../types/transactionDetail'
import { createActions } from './createActions'
import { decodeTransaction } from './decodeTransaction'
import { getDataFromDatasource } from './getDataFromDatasource'

type AnalyzeTransactionParameters = {
  readonly chain: Chain
  readonly transaction: TransactionDetail
  readonly datasource: AnalyzeDataSource
  readonly relatedAddresses: readonly LowerHex[]
  readonly converter?: Converter
}

type AnalyzeTransactionReturnTypes = {
  readonly transaction: TransactionDecoded
  readonly actions: readonly Action[]
}

export const analyzeTransaction = async ({
  chain,
  transaction,
  datasource,
  relatedAddresses,
  converter,
}: AnalyzeTransactionParameters): Promise<AnalyzeTransactionReturnTypes> => {
  const addressSet = new Set(relatedAddresses)
  const {
    addresses,
    erc20Tokens,
    eventAbis,
    functionAbis,
    jsonAnalyzers,
    nfts,
  } = await getDataFromDatasource({
    chain,
    transaction,
    datasource,
    relatedAddresses: addressSet,
  })

  const transactionDecoded = decodeTransaction({
    transaction,
    addresses,
    erc20Tokens,
    eventAbis,
    functionAbis,
    nfts,
  })

  const actions = await createActions({
    chain,
    transaction: transactionDecoded,
    relatedAddresses: addressSet,
    converter,
    jsonAnalyzers,
  })

  return {
    transaction: transactionDecoded,
    actions,
  }
}
